import React, { useState } from 'react'; // Importamos useState para manejar el modal

const Pruebas = ({ pruebasList }) => {
  // Estado para guardar el examen que se quiere revisar
  const [activePreview, setActivePreview] = useState(null);

  // Selector de estilos por modalidad
  const getModalityClass = (mod) => {
    const normalized = mod?.toLowerCase();
    if (normalized === 'presencial') return 'bg-rose-50 text-rose-600 border-rose-100';
    if (normalized === 'virtual') return 'bg-emerald-50 text-emerald-600 border-emerald-100';
    return 'bg-blue-50 text-blue-600 border-blue-100';
  };

  return (
    <div className="space-y-10 animate-fadeIn text-slate-800">
      
      {/* 1. ENCABEZADO DEL WIDGET */}
      <div className="text-center">
        <h3 className="text-2xl md:text-3xl font-black text-slate-900 tracking-tight">
          Exámenes Realizados por Nosotros
        </h3>
        <p className="text-slate-500 text-sm md:text-base mt-1.5 font-medium">
          Evidencia real de nuestro trabajo y resultados obtenidos
        </p>
      </div>

      {/* 2. RECUADRO DE PRIVACIDAD Y SEGURIDAD */}
      <div className="bg-amber-50/50 border border-amber-200/70 rounded-2xl p-5 md:p-6 text-left max-w-4xl mx-auto space-y-3 shadow-inner">
        <div className="flex items-center gap-2 text-amber-800 font-bold text-sm">
          <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751A11.956 11.956 0 0112 2.714z" />
          </svg>
          <span>Aviso de Privacidad y Seguridad</span>
        </div>
        <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-1.5 text-xs md:text-sm font-semibold text-slate-600 pl-1">
          <li className="flex items-center gap-2"><span className="text-amber-500">•</span> Toda la información mostrada cuenta con autorización expresa del cliente</li>
          <li className="flex items-center gap-2"><span className="text-amber-500">•</span> Los datos personales han sido censurados por motivos de seguridad</li>
          <li className="flex items-center gap-2"><span className="text-amber-500">•</span> Mantenemos estricta confidencialidad en todos nuestros servicios</li>
          <li className="flex items-center gap-2"><span className="text-amber-500">•</span> Somos discretos y profesionales en cada proyecto</li>
        </ul>
      </div>

      {/* 3. GRILLA DE TARJETAS DINÁMICAS */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto mt-8">
        {pruebasList && pruebasList.map((item, idx) => (
          <div 
            key={idx} 
            className="bg-white border border-slate-200/80 rounded-3xl overflow-hidden shadow-sm flex flex-col justify-between text-left group hover:shadow-md transition-all duration-300"
          >
            {/* Contenedor Superior: Imagen con click para abrir la vista previa */}
            <div 
              onClick={() => setActivePreview(item)} 
              className="bg-slate-50 aspect-[4/5] w-full border-b border-slate-100 overflow-hidden flex items-center justify-center relative cursor-zoom-in group/img"
            >
              <img 
                src={item.imgUrl} 
                alt={`Evidencia de ${item.title}`}
                className="w-full h-full object-cover transition-transform duration-500 group-hover/img:scale-105"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentNode.innerHTML = `
                    <div class="flex flex-col items-center gap-2 text-slate-300 font-bold text-xs p-4">
                      <svg class="w-12 h-12 stroke-current" fill="none" stroke-width="1.8" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                      </svg>
                      <span>Ver Documento</span>
                    </div>
                  `;
                }}
              />
              {/* Capa de Hover que invita a expandir la foto */}
              <div className="absolute inset-0 bg-black/0 group-hover/img:bg-black/10 transition-colors flex items-center justify-center">
                <span className="bg-white/95 text-slate-800 font-bold text-xs px-3 py-1.5 rounded-xl shadow-sm opacity-0 group-hover/img:opacity-100 transition-opacity">
                  Click para ver examen
                </span>
              </div>
            </div>

            {/* Contenedor Inferior: Textos y Datos */}
            <div className="p-5 flex flex-col justify-between flex-grow gap-4">
              <div className="space-y-3">
                <div className="flex items-center justify-between text-xs font-bold">
                  <span className={`px-2.5 py-1 rounded-lg border uppercase tracking-wide text-[10px] ${getModalityClass(item.modality)}`}>
                    {item.modality}
                  </span>
                  <div className="flex items-center gap-1 text-slate-700">
                    <svg className="w-3.5 h-3.5 text-amber-500 fill-current" viewBox="0 0 24 24">
                      <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                    </svg>
                    <span>{item.rating || "5.0"}/5.0</span>
                  </div>
                </div>

                <div className="space-y-1">
                  <h4 className="font-black text-slate-800 text-sm md:text-base tracking-tight leading-snug">
                    {item.title} - {item.university}
                  </h4>
                  <div className="flex items-center gap-2 text-[11px] font-bold text-slate-400 uppercase tracking-wider">
                    <span>{item.date}</span>
                    {item.country && (
                      <><span>•</span><span>{item.country}</span></>
                    )}
                  </div>
                </div>
              </div>

              {/* Botón de inspección que abre el visualizador modal */}
              <button 
                onClick={() => setActivePreview(item)}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-extrabold text-xs py-3 rounded-xl flex items-center justify-center gap-2 transition-colors shadow-sm tracking-wide"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51a11.94 11.94 0 0119.928 0c.346.608.346 1.346 0 1.954a11.94 11.94 0 01-19.928 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                Revisar Documento
              </button>
            </div>

          </div>
        ))}
      </div>

      {/* ========================================================= */}
      {/* 4. MODAL DETALLADO DE VISTA PREVIA (Lightbox - image_e9329f) */}
      {/* ========================================================= */}
      {activePreview && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[150] flex items-center justify-center p-4 animate-fadeIn">
          
          {/* Caja del Modal */}
          <div className="bg-white rounded-3xl w-full max-w-3xl max-h-[94vh] flex flex-col overflow-hidden shadow-2xl border border-slate-200">
            
            {/* Cabezal del visualizador */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100 flex-shrink-0 bg-white">
              <h4 className="font-black text-slate-900 text-sm md:text-base tracking-tight text-left">
                {activePreview.title} - {activePreview.university}
              </h4>
              <button 
                onClick={() => setActivePreview(null)}
                className="text-slate-400 hover:text-slate-900 p-1.5 rounded-xl hover:bg-slate-50 transition-colors font-bold text-sm flex items-center gap-1"
              >
                ✕
              </button>
            </div>

            {/* Contenedor central: Renderiza la captura del examen con scroll si es muy larga */}
            <div className="p-4 md:p-6 bg-slate-100 overflow-y-auto flex-grow flex items-center justify-center min-h-[350px]">
              <img 
                src={activePreview.imgUrl} 
                alt="Examen resuelto evidencia" 
                className="max-w-full max-h-[58vh] md:max-h-[62vh] object-contain rounded-xl shadow-md border border-slate-200"
              />
            </div>

            {/* Pie de página del visualizador */}
            <div className="px-6 py-4 border-t border-slate-100 flex flex-row items-center justify-between gap-4 bg-white flex-shrink-0">
              
              {/* Metadatos alineados a la izquierda */}
              <div className="text-left text-xs md:text-sm font-semibold text-slate-400 space-y-0.5">
                <p>Fecha: <span className="text-slate-800 font-bold">{activePreview.date}</span></p>
                <p>Calificación: <span className="text-slate-800 font-bold">{activePreview.rating}/5.0</span></p>
                <p>Tipo: <span className="text-slate-800 font-bold">{activePreview.modality}</span></p>
              </div>

              {/* Botón de descarga alineado a la derecha */}
              <a 
                href={activePreview.fileUrl}
                target="_blank"
                rel="noreferrer"
                className="bg-blue-600 hover:bg-blue-700 text-white font-extrabold text-xs md:text-sm px-6 py-3 rounded-xl flex items-center gap-2 transition-colors shadow-md shadow-blue-600/10"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
                </svg>
                Descargar
              </a>

            </div>

          </div>
        </div>
      )}

    </div>
  );
};

export default Pruebas;